import { useTranslation } from 'react-i18next';

import { ItemList } from '@/components/ItemList';
import { StatusSeenChipInTable } from '@/components/StatusSeenChipInTable';
import { UserAction } from '@/components/UserAction';
import { useChannelId } from '@/features/broadcasters/api/get-channel-id';
import { CNMC } from '@/features/cnmcs/types';
import { getHoursRange } from '@/utils/get-hours-range';

type CNMCDetailCard = {
  cnmc: CNMC;
};

export function CNMCDetail({ cnmc }: CNMCDetailCard) {
  const { t } = useTranslation();
  const { data: channel } = useChannelId({
    id: cnmc.channel,
  });

  return (
    <div className="flex flex-1 flex-col items-start self-stretch">
      <div className="flex w-full flex-col divide-y divide-stroke-20">
        <ItemList title={t('Descripción')}>{cnmc.description}</ItemList>
        <ItemList title={t('Emisora')}>{channel?.name}</ItemList>
        <ItemList title={t('Proveedor')}>{cnmc.provider}</ItemList>
        <ItemList title={t('Hora')}>
          {getHoursRange(cnmc.start_datetime, cnmc.end_datetime)}
        </ItemList>
        {/* <ItemList title={t('Emails')}>{cnmc.recipients}</ItemList> */}
        <ItemList title={t('Tiempo restante')}>00:60:25</ItemList>
        <ItemList title={t('Estado')}>
          <StatusSeenChipInTable classname="w-fit" review_state={1} />
        </ItemList>
        <ItemList title={t('Creado por')}>
          <UserAction id={cnmc.created_by} timestamp={cnmc.created_at} />
        </ItemList>
        <ItemList title={t('Actualizado por')}>
          <UserAction
            id={cnmc.updated_by ?? cnmc.created_by}
            timestamp={cnmc.updated_at ?? cnmc.created_at}
          />
        </ItemList>
      </div>
    </div>
  );
}
